import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TicketDetail } from "@/components/support/TicketDetail";

export const Route = createFileRoute("/_public/help/tickets/$id")({
	component: TicketDetailPage,
});

function TicketDetailPage() {
	const { id } = Route.useParams();
	const navigate = useNavigate();

	const handleBack = () => {
		navigate({ to: "/help/tickets" });
	};

	return <TicketDetail ticketId={Number(id)} onBack={handleBack} />;
}
